import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as eventKeys from '../lib/events';

require('../lib/gsap/MorphSVGPlugin');

export default (el, props) => {
    const $el = $(el);
    const $svg = $el.find('svg');
    const $path = $svg.find('path');
    
    const originalPath = 'M13.5,0C6,0,0,6,0,13.5c0,3.3,1.6,5.7,2.3,6.7C2.9,21.3,13.5,36,13.5,36s10.6-14.7,11.2-15.8c0.7-1.1,2.3-3.5,2.3-6.7C27,6,21,0,13.5,0z M13.5,19.1c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6S16.6,19.1,13.5,19.1z';
    const hoverPath = 'M13.5,0C6,0,0,6,0,13.5C0,21,6,27,13.5,27S27,21,27,13.5C27,6,21,0,13.5,0z M13.5,19.1c-3.1,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6S16.6,19.1,13.5,19.1z';
    
    const onResize = () => {
        
    };
    
    const init = () => {
        $path.attr('d', originalPath);
        
        $el.on('mouseenter', () => {
            TweenMax.to($path.get(0), 0.1, {
                morphSVG: hoverPath,
                ease: Power2.easeInOut
            });
        });
        
        $el.on('mouseleave', () => {
            TweenMax.to($path.get(0), 0.1, {
                morphSVG: originalPath,
                ease: Power2.easeInOut
            });
        });
        
        Viewport.on('resize', onResize);
    };
    
    const destroy = () => {
        $el.off('mouseenter');
        $el.off('mouseleave');
        
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/MapButtonAnim.js